module.exports = __webpack_public_path__ + "static/media/postcard10thumb.1af5b5fd.jpg";